import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { createMeterReading, getContract } from '../../../../services/contracts.service';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../../services/error-message.service';
import { ContractDto } from '../../../../services/dtos/contract.dto';
import { useSnackbars } from '../../../../hooks/snackbar.hook';
import { getRequestMeterReading } from '../../../../services/requests.service';
import { AskDto } from '../../../../services/dtos/ask.dto';
import MeterReadingForm from '../../../../components/forms/meter-reading/meter-reading.form';
import { MeterReadingDto } from '../../../../services/dtos/meter-reading.dto';
import moment from 'moment';

/**
 * Page relevé de compteur
 * @constructor
 */
export default function MeterReadingPage() {
    //Navigate pour aller sur une nouvelle page
    const navigate = useNavigate();
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    //Params
    const { id } = useParams();
    //Ajout des useState
    const [lastAsk, setLastAsk] = useState<AskDto | undefined>();
    const [address, setAddress] = useState<string | undefined>();
    const [validForm, setValidForm] = useState(true);

    //Use effect
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;
        //Récupération du contrat pour afficher l'adresse
        getContract(id)
            .then((contract: ContractDto) => {
                setAddress(contract?.informations?.abonne?.adresse);
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            });
        //Récupération de la dernière demande
        getRequestMeterReading(id)
            .then(asks => {
                if (asks.length === 1) {
                    setLastAsk(asks[0]);
                }
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            });
    }, [showMessage, id]);

    //Handler utilisé lors du submit du formulaire
    const handleSumbitForm = (values: any) => {
        setValidForm(false);
        //Concaténation des champs en une seul valeur
        const index =
            values.numberOne?.toString() +
            values.numberTwo?.toString() +
            values.numberThree?.toString() +
            values.numberFour?.toString() +
            values.numberFive?.toString();
        //Création du DTO
        const meterReadingDto: MeterReadingDto = {
            date: moment(values.date, true).format('yyyy-MM-DD'),
            index: parseInt(index),
        };
        //Appel API pour la création du relevé de compteur
        createMeterReading(meterReadingDto, id)
            .then(() => {
                showMessage.successAlert('Votre relevé de compteur a bien été pris en compte.');
                navigate('/contrat/' + id + '/demandes');
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setValidForm(true);
            });
    };

    //Appel de la vue qui est retournée
    return (
        <MeterReadingForm
            lastAsk={lastAsk}
            address={address}
            handleSumbitForm={handleSumbitForm}
            validForm={validForm}
            id={id}
        ></MeterReadingForm>
    );
}
